import { BaseApiClient } from './base-client';

/**
 * Consent API — sends cookie / registration consent records to the backend.
 * Backend appends to consent_log (FZ-152 / FZ-156 audit trail).
 */
export class ConsentApi extends BaseApiClient {
  /**
   * Cookie banner choice. Best-effort — failures don't block the UI.
   */
  async cookie(input: {
    anonSessionId: string;
    version: string;
    functional: boolean;
    analytics: boolean;
  }): Promise<void> {
    try {
      await this.client.post('/api/consent/cookie', input);
    } catch {
      // do not block UI on consent log failure
    }
  }

  /**
   * Registration consent package (18+, PD processing, offer, privacy, cookie).
   * Caller MUST await success before initiating OAuth / Telegram login on .ru.
   * Returns true on 200, false otherwise — caller should refuse to proceed if false.
   */
  async registration(input: {
    anonSessionId: string;
    version: string;
    age18: boolean;
    pdProcessing: boolean;
    offer: boolean;
    privacy: boolean;
    cookie: boolean;
  }): Promise<boolean> {
    try {
      const response = await this.client.post('/api/consent/registration', input);
      return Boolean(response.data?.success);
    } catch {
      return false;
    }
  }
}
